// extracted by mini-css-extract-plugin
export default {"dateMenu":"dateMenu___Vo8Md"};